import {
  BarChart3,
  BellRing,
  BotMessageSquare,
  BrainCircuit,
  Bug,
  Building2,
  CalendarClock,
  Clapperboard,
  ClipboardList,
  Dumbbell,
  FileStack,
  FileText,
  Gift,
  GitBranch,
  GitPullRequest,
  Globe,
  Handshake,
  Headphones,
  Heart,
  Inbox,
  Languages,
  ListChecks,
  Hourglass,
  Mailbox,
  MailX,
  Megaphone,
  MessageCircleQuestion,
  Microscope,
  Moon,
  Newspaper,
  NotebookPen,
  Package,
  PenLine,
  Plane,
  Radar,
  Receipt,
  Rocket,
  Route,
  Scale,
  ShieldAlert,
  ShieldCheck,
  Sparkles,
  Timer,
  UserRoundCheck,
  type LucideIcon,
} from "lucide-react";

const LANDING_AGENT_ICONS: Record<string, LucideIcon> = {
  Headphones,
  Microscope,
  CalendarClock,
  BarChart3,
  Handshake,
  Building2,
  Radar,
  Sparkles,
  FileText,
  NotebookPen,
  Receipt,
  MailX,
  Inbox,
  Plane,
  Dumbbell,
  Languages,
  Gift,
  Newspaper,
  ShieldAlert,
  ShieldCheck,
  GitPullRequest,
  GitBranch,
  Megaphone,
  Clapperboard,
  Globe,
  ListChecks,
  BellRing,
  MessageCircleQuestion,
  Bug,
  PenLine,
  Scale,
  Rocket,
  Package,
  ClipboardList,
  Moon,
  Timer,
  Hourglass,
  Mailbox,
  UserRoundCheck,
  Route,
  Heart,
  BrainCircuit,
  BotMessageSquare,
};

export function LandingAgentIcon({
  iconKey,
  className,
}: {
  iconKey?: string | null;
  className?: string;
}) {
  const Icon = iconKey
    ? (LANDING_AGENT_ICONS[iconKey] ?? FileStack)
    : FileStack;
  return <Icon className={className} aria-hidden />;
}
